<template>
  <div class="text-left px-6 pb-12 bg-gray-50">
    <div class="pt-11 flex justify-between items-center">
      <div @click="back">
        <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
      </div>
      <div @click="close">
        <close-icon :width="'w-4'" :color="'text-nw-red'"></close-icon>
      </div>
    </div>
    <div class="pt-8">
      <div class="text-lg font-bold">Where are we picking up?</div>
    </div>
    <div class="pt-4 relative">
      <div class="text-xxs text-nw-ash" v-if="pick.location != ''">Pick-up location*</div>
      <input-text type="text" v-model="pick.location" placeholder="Pick-up location*"></input-text>
      <div
        @click="popPickup(true)"
        class="w-full absolute z-20 py-5 text-sm font-medium focus:outline-none -mt-10"
      ></div>
    </div>
    <pick-up-pop
      v-if="show_pick_pop"
      v-on:open-pop="popPickup"
      v-on:pick-location="pickUpLocationSelected"
    ></pick-up-pop>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="pick.sender_name != ''">Sender Full Name*</div>
      <input-text type="text" v-model="pick.sender_name" placeholder="Sender Full Name*"></input-text>
    </div>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="pick.phone_number != ''">Phone Number*</div>
      <input-text type="text" v-model="pick.phone_number" placeholder="Phone Number*"></input-text>
    </div>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="pick.email != ''">Email (Optional)</div>
      <input-text type="text" v-model="pick.email" placeholder="Email (Optional)"></input-text>
    </div>
    <div class="pt-2" @click="open_category = !open_category">
      <div class="text-xxs text-nw-ash" v-if="pick.category != ''">Select Category*</div>
      <input-text type="text" v-model="pick.category" readonly placeholder="Select Category*"></input-text>
      <div class="-mt-8 mr-2 text-right">
        <add-icon></add-icon>
      </div>
    </div>
    <category
      v-if="open_category"
      v-on:category="closeCategory"
      v-on:selected-category="selectedCategory"
      :category="pick.category"
    ></category>
    <div class="pt-4">
      <div class="text-xxs text-nw-ash" v-if="pick.time_pick_up != ''">Date &amp; Time for Pick-up*</div>
      <datetime
        v-model="pick.time_pick_up"
        type="datetime"
        class="border-b red w-full py-2 text-sm focus:outline-none"
        placeholder="Date &amp; Time for Pick-up*"
        use12-hour
      ></datetime>
    </div>
    <!-- <div class="pt-2 float-right" v-if="details ? details.initiator == 'receiver' : false">
      <p class="text-nw-ash inline-block text-xs mr-2">Save Contact Details</p>
      <div class="inline-block" @click="save_contact = true">
        <div v-if="!save_contact" class="w-4 h-4 focus:outline-none border border-nw-red rounded-sm"></div>
      </div>
      <div @click="save_contact = false" v-if="save_contact" class="inline-block">
        <check-icon :width="'w-4 -mt-2'"></check-icon>
      </div>
    </div> -->
    <div class="pt-20">
      <div class="text-lg font-bold">Where are we delivering to?</div>
    </div>
    <div class="pt-4 relative">
      <div class="text-xxs text-nw-ash" v-if="delivering.location != ''">Delivery location*</div>
      <input-text type="text" v-model="delivering.location" placeholder="Delivery location*"></input-text>
      <div
        @click="popDelivery(true)"
        class="w-full absolute z-20 py-5 text-sm font-medium focus:outline-none -mt-10"
      ></div>
    </div>
    <delivery-pop
      v-if="show_delivery_pop"
      v-on:open-deliverypop="popDelivery"
      v-on:delivery-location="deliveryLocationSelected"
    ></delivery-pop>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="delivering.receiver_name != ''">Receiver’s Full Name*</div>
      <input-text type="text" v-model="delivering.receiver_name" placeholder="Receiver’s Full Name*"></input-text>
    </div>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="delivering.phone_number != ''">Phone Number*</div>
      <input-text type="text" v-model="delivering.phone_number" placeholder="Phone Number*"></input-text>
    </div>
    <div class="pt-2">
      <div class="text-xxs text-nw-ash" v-if="delivering.email != ''">Email (Optional)</div>
      <input-text type="text" v-model="delivering.email" placeholder="Email (Optional)"></input-text>
    </div>
    <div class="inline" @click="add_note = true">
      <div class="inline-block pt-4">
        <add-icon></add-icon>
      </div>
      <div class="text-sm text-nw-ash font-extrabold inline-block pl-2 pt-4">Add a delivery note</div>
    </div>
    <!-- <div class="pt-2 text-right" v-if="details ? details.initiator == 'sender' : false">
      <p class="text-nw-ash inline-block text-xs mr-2">Save Contact Details</p>
      <div class="inline-block" @click="save_contact = true">
        <div v-if="!save_contact" class="w-4 h-4 focus:outline-none border border-nw-red rounded-sm"></div>
      </div>
      <div @click="save_contact = false" v-if="save_contact" class="inline-block">
        <check-icon :width="'w-4 -mt-2'"></check-icon>
      </div>
    </div> -->
    <save-note v-if="add_note" :note="delivery_note" v-on:add-note="addNote"></save-note>
    <div class="pt-7 grid grid-cols-2 gap-x-3 text-xs">
      <div @click="next">
        <input-button>CONTINUE</input-button>
      </div>
      <div @click="show_map = true" v-if="pick.location != '' && delivering.location != ''">
        <input-button :bg="'bg-nw-ash hover:bg-gray-500'">SEE ROUTE</input-button>
      </div>
    </div>
    <div id="map"></div>
    <see-map
      v-if="show_map"
      :from="pick.location"
      :to="delivering.location"
      v-on:open-map="openMap"
      :coordinates="delivering.coordinates"
    ></see-map>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddIcon from '../icons/AddIcon.vue'
import BackArrowIcon from '../icons/BackArrowIcon.vue'
// import CheckIcon from '../icons/CheckIcon.vue'
import InputButton from '../inputs/InputButton.vue'
import InputText from '../inputs/InputText.vue'
import Category from './Category.vue'
import SaveNote from './SaveNote.vue'
import { Datetime } from 'vue-datetime'
import Swal from 'sweetalert2'
import SeeMap from './SeeMap.vue'
import CloseIcon from '../icons/CloseIcon.vue'
import PickUpPop from './PickUpPop.vue'
import DeliveryPop from './DeliveryPop.vue'

export default {
  props: {
    id: [String, Number]
  },
  components: {
    BackArrowIcon,
    InputText,
    AddIcon,
    Category,
    InputButton,
    SaveNote,
    // CheckIcon,
    Datetime,
    SeeMap,
    CloseIcon,
    PickUpPop,
    DeliveryPop
  },
  data() {
    return {
      pick: {
        location: '',
        coordinates: {},
        sender_name: '',
        phone_number: '',
        email: '',
        category: '',
        time_pick_up: '',
        region_details: {}
      },
      delivering: {
        location: '',
        coordinates: {},
        receiver_name: '',
        phone_number: '',
        email: '',
        region_details: {}
      },
      delivery_note: null,
      save_contact: false,
      add_note: false,
      open_category: false,
      show_map: false,
      show_pick_pop: false,
      show_delivery_pop: false
    }
  },
  watch: {
    details() {
      this.placeOtherDetails()
    },
    pick: {
      deep: true,
      handler(val) {
        if (val.time_pick_up != '') {
          this.clearPickUpTime(val.time_pick_up)
        }
      }
    }
  },
  computed: {
    user_details() {
      return this.$store.state.user_details
    },
    user() {
      return this.$store.state.user
    },
    ...mapState('arrange_details', ['details'])
  },
  methods: {
    back() {
      this.$emit('show-who', true)
    },
    close() {
      this.$emit('close-all', true)
    },
    openMap(val) {
      this.show_map = val
    },
    closeCategory(val) {
      this.open_category = val
    },
    selectedCategory(val) {
      this.pick.category = val
    },
    addNote(val) {
      this.add_note = val.close
      this.delivery_note = val.delivery_note
    },
    next() {
      console.log(this.pick, this.delivering)
      if (this.validator()) {
        var details = {
          id: this.id,
          pick_up: this.pick,
          delivering: this.delivering,
          delivery_note: this.delivery_note
        }
        this.$emit('details', details)
        this.$store.dispatch('arrange_details/submitOrderArrangements', details).then(() => {
          this.$emit('show-payment', true)
        })
      }
    },
    validator() {
      if (
        this.pick.location != '' &&
        this.pick.sender_name != '' &&
        this.pick.phone_number != '' &&
        this.pick.category != '' &&
        this.pick.time_pick_up != ''
      ) {
        if (
          this.delivering.location != '' &&
          this.delivering.receiver_name != '' &&
          this.delivering.phone_number != ''
        ) {
          if (this.delivery_note != undefined || this.delivery_note == null) {
            if (this.pick.region_details != undefined && this.delivering.region_details != undefined) {
              if (this.pick.region_details.state == this.delivering.region_details.state) {
                return true
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Ooops',
                  html: 'Your Delivery and pick up locations are not within the same state. <a href="tel:08063766804" class="text-blue-400 underline">contact us</a>'
                })
              }
            } else {
              Swal.fire({
                icon: 'info',
                title: 'Ooops',
                html: 'You are trying to order from a region outside our reach <a href="tel:08063766804" class="text-blue-400 underline">contact us</a>'
              })
              // return true
            }
          } else {
            Swal.fire('', 'Please add a delivery note', 'info')
          }
        } else {
          Swal.fire('', 'Missing Information', 'info')
        }
      } else {
        Swal.fire('', 'Missing Information', 'warning')
      }
    },
    placeInitiatorDetails() {
      if (this.details) {
        this.clear()
        if (this.details.initiator === 'sender') {
          this.pick.sender_name = this.user_details.first_name + ' ' + this.user_details.last_name
          this.pick.phone_number = this.user.phoneNumber
          this.pick.email = this.user_details.email
        } else {
          this.delivering.receiver_name = this.user_details.first_name + ' ' + this.user_details.last_name
          this.delivering.phone_number = this.user.phoneNumber
          this.delivering.email = this.user_details.email
        }
      }
    },
    placeOtherDetails() {
      if (this.details) {
        this.delivery_note = this.details.delivery_note ? this.details.delivery_note : null
        if (this.details.pick_up) {
          this.pick.location = this.details.pick_up.location
          this.pick.email = this.details.pick_up.email
          this.pick.sender_name = this.details.pick_up.sender_name
          this.pick.phone_number = this.details.pick_up.phone_number
          this.pick.category = this.details.pick_up.category
          this.pick.coordinates = this.details.pick_up.coordinates
          this.pick.time_pick_up = this.details.pick_up.time_pick_up
          this.pick.region_details = this.details.pick_up.region_details
        } else {
          this.placeInitiatorDetails()
        }

        if (this.details.delivering) {
          this.delivering.location = this.details.delivering.location
          this.delivering.coordinates = this.details.delivering.coordinates
          this.delivering.email = this.details.delivering.email
          this.delivering.receiver_name = this.details.delivering.receiver_name
          this.delivering.phone_number = this.details.delivering.phone_number
          this.delivering.region_details = this.details.delivering.region_details
        } else {
          this.placeInitiatorDetails()
        }
      }
    },
    clear() {
      this.delivering.receiver_name = ''
      this.delivering.phone_number = ''
      this.delivering.email = ''

      this.pick.sender_name = ''
      this.pick.phone_number = ''
      this.pick.email = ''
    },
    popPickup(val) {
      this.show_pick_pop = val
    },
    pickUpLocationSelected(val) {
      this.pick.coordinates = val.pick.coordinates
      this.pick.location = val.pick_location
      this.pick.region_details = val.pick.region_details
    },
    popDelivery(val) {
      this.show_delivery_pop = val
    },
    deliveryLocationSelected(val) {
      this.delivering.coordinates = val.delivering.coordinates
      this.delivering.location = val.delivery_location
      this.delivering.region_details = val.delivering.region_details
    },
    getHours(time) {
      var today = new Date(time)
      var hours = today.getHours()

      return hours
    },
    clearPickUpTime(time_pick_up) {
      if (this.getHours(time_pick_up) > 19) {
        Swal.fire({
          title: 'Info',
          text: `Sorry, our opening hours is between 8am and 6pm, we are closed.`,
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `Okay`,
          denyButtonText: ``
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.pick.time_pick_up = ''
          }
        })
      } else if (this.getHours(time_pick_up) < 8) {
        Swal.fire({
          title: 'Info',
          text: `Sorry, our opening hours is between 8am and 6pm, you are early.`,
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `Okay`,
          denyButtonText: ``
        }).then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.pick.time_pick_up = ''
          }
        })
      }
    }
  },
  created() {
    this.$store.dispatch('arrange_details/getOrderArrangements', this.id)
    this.$store.dispatch('arrange_details/readRegions')
  },
  mounted() {
    this.placeOtherDetails()
  }
}
</script>

<style>
.vdatetime-input {
  @apply w-full;
  @apply bg-gray-50;
  @apply font-medium;
}

.red .vdatetime-popup__header,
.red .vdatetime-calendar__month__day--selected > span > span,
.red .vdatetime-calendar__month__day--selected:hover > span > span {
  @apply bg-nw-red;
}

.red .vdatetime-year-picker__item--selected,
.red .vdatetime-time-picker__item--selected,
.red .vdatetime-popup__actions__button {
  @apply text-nw-red;
}
</style>
